import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { connect } from 'react-redux';
import { clearPatchCustomTheme } from 'redux/themes/actions';
import { setMe } from 'redux/users/actions';

import AddCryptoLinkForm from 'components/dashboard/crypto-links-content/AddCryptoLinkForm';
import CryptoColorSelector from 'components/dashboard/crypto-links-content/CryptoColorSelector';
import CryptoLinksList from 'components/dashboard/crypto-links-content/CryptoLinksList';
import SocialNetworkRequestContent
  from 'components/dashboard/social-content/SocialNetworkRequestContent';

import './CryptoLinksPageContent.css';


function CryptoLinksPageContent(props) {
  const {
    setMe,
    clearPatchCustomTheme,
    patchCustomThemeSuccess,
    cryptoLinksList,
  } = props;
  const { t } = useTranslation();

  useEffect(() => {
    if (patchCustomThemeSuccess) {
      setMe(patchCustomThemeSuccess);
      clearPatchCustomTheme();
    }
  }, [patchCustomThemeSuccess]);

  return (
    <div className="crypto-links-page-content__component">
      <AddCryptoLinkForm />
      {cryptoLinksList && cryptoLinksList.length > 0 &&
        <div className="color-selectors-wrapper">
          <CryptoColorSelector
            key="crypto-link-background-color-selector"
            type="btn"
            label={t("Crypto Button Color")}
            parameter="crypto_button_color"
          />
          <CryptoColorSelector
            key="crypto-link-font-color-selector"
            type="fnt"
            label={t("Crypto Button Font Color")}
            parameter="crypto_font_color"
          />
        </div>
      }
      <CryptoLinksList />
      <SocialNetworkRequestContent type="Crypto" />
    </div>
  );
};

CryptoLinksPageContent.propTypes = {
  setMe: PropTypes.func.isRequired,
  clearPatchCustomTheme: PropTypes.func.isRequired,
  patchCustomThemeSuccess: PropTypes.object,
  cryptoLinksList: PropTypes.arrayOf(PropTypes.shape),
};

CryptoLinksPageContent.defaultProps = {
  patchCustomThemeSuccess: null,
  cryptoLinksList: null,
};

const mapStateToProps = state => (
  {
    patchCustomThemeSuccess: state.themesReducer.patchCustomThemeSuccess,
    cryptoLinksList: state.cryptoLinksReducer.cryptoLinksList,
  }
);

export default connect(
  mapStateToProps,
  {
    setMe,
    clearPatchCustomTheme,
  },
)(CryptoLinksPageContent);

